/*/=======================================================================================\*\
|| RUTAS DEL PROYECTO                                                                      ||
\*\=======================================================================================/*/

export const ROUTES = {
  // Inicio Sitio
  inicio: '/',
  queCasinoPrint: '/que-es-casino-print',
  login: '/login',
  register: '/register',
  verificarEmail: '/verificar-email',
  olvidoContrasenia: '/olvido-contrasenia',
  resetContrasenia: '/reset-contrasenia',
  // Juegos
  juegos: '/juegos',
  listaJuegos: '/juegos/listaJuegos',
  ruleta: '/juegos/ruleta',
  tragamonedas: '/juegos/tragamonedas',
  blackJack: '/juegos/blackJack',
  // Historial
  historial: '/historial',
  // Detalle Jugada
  detallesJugada: '/detallesJugada',
  // Detalle jugada con Id Movimiento Saldo
  detallesJugadaMovimientoId: '/detallesJugadaMovimientoId',
  // Movimientos
  movimientos: '/movimientos',
  // Ranking
  ranking: '/ranking',
  // Historial de jugador público
  historialJugador: '/historial/jugador',
  // Admin
  admin: '/admin',
  adminUsuarioDetalle: '/admin/usuario',
  // CargarSaldo
  listaCargaSaldo: '/cargarSaldo/listaCargaSaldo',
  eleccionCargaSaldo: '/cargarSaldo/eleccionCargaSaldo',
  mercadoPagoFailure: '/cargarSaldo/MercadoPagoFailure',
  mercadoPagoPending: '/cargarSaldo/MercadoPagoPending',
  mercadoPagoSuccess: '/cargarSaldo/MercadoPagoSuccess',
  // Perfil
  perfil: '/perfil',
  // Editar Perfil
  editarPerfil: '/editarPerfil',

  /*/=======================================================================================\*\
  || ASSETS DEL SITIO                                                                        ||
  \*\=======================================================================================/*/
  rutaAvatares: '/assets/imagenesSitio/avatares/',
  rutaBanners: '/assets/imagenesSitio/banners/',
  rutaIlustraciones: '/assets/imagenesSitio/ilustraciones/',
  rutaFichasPoker: '/assets/imagenesSitio/fichasPoker/',
  rutaLogos: '/assets/imagenesSitio/logos/',
  rutaPortadasJuegos: '/assets/imagenesSitio/portadasJuegos/',

  /*/=======================================================================================\*\
  || ASSETS RULETA                                                                           ||
  \*\=======================================================================================/*/
  rutaRuletaAlfombra: '/assets/imagenesJuegos/juegoRuleta/alfombra',
  rutaRuletaBolilla: '/assets/imagenesJuegos/juegoRuleta/bolilla',
  rutaRuletaBotones: '/assets/imagenesJuegos/juegoRuleta/botones',
  rutaRuletaCarteles: '/assets/imagenesJuegos/juegoRuleta/carteles',
  rutaRuletaDisplayMonto: '/assets/imagenesJuegos/juegoRuleta/displayMonto',
  rutaRuletaFichasAlfombra: '/assets/imagenesJuegos/juegoRuleta/fichasAlfombra',
  rutaRuletaFichasEleccion: '/assets/imagenesJuegos/juegoRuleta/fichasEleccion',
  rutaRuletaNumerosDisplay: '/assets/imagenesJuegos/juegoRuleta/numerosDisplay',
  rutaRuletaRuleta: '/assets/imagenesJuegos/juegoRuleta/ruleta',
  rutaRuletaUltimosNumeros: '/assets/imagenesJuegos/juegoRuleta/ultimosNumeros',
  rutaRuletaValoresGanadores:
    '/assets/imagenesJuegos/juegoRuleta/valoresGanadores',
  rutaRuletaPantallaCarga: '/assets/imagenesJuegos/juegoRuleta/pantallaCarga',

  /*/=======================================================================================\*\
  || ASSETS RULETA - PARA MOSTRAR RESULTADOS EN EL SITIO                                     ||
  \*\=======================================================================================/*/
  rutaRuletaValoresAlfombraCalle:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/calle',
  rutaRuletaValoresAlfombraChances:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/chances',
  rutaRuletaValoresAlfombraDoblesHorizontal:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/doblesHorizontal',
  rutaRuletaValoresAlfombraDoblesVertical:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/doblesVertical',
  rutaRuletaValoresAlfombraEsquina:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/esquina',
  rutaRuletaValoresAlfombraNumeros:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/numeros',
  rutaRuletaValoresAlfombraSextaLinea:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/sextaLinea',
  rutaRuletaValoresAlfombra:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra',
  rutaRuletaTodosValoresAlfombra:
    '/assets/imagenesJuegos/juegoRuleta/valoresAlfombra/todosLosValores',

  /*/=======================================================================================\*\
  || ASSETS TRAGAMONEDAS                                                                     ||
  \*\=======================================================================================/*/
  rutaTragamonedasPantallaCarga:
    '/assets/imagenesJuegos/juegoTragamonedas/pantallaCarga',
  rutaTragamonedasDisposicion:
    '/assets/imagenesJuegos/juegoTragamonedas/disposicion',
  rutaTragamonedasBotones: '/assets/imagenesJuegos/juegoTragamonedas/botones',
  rutaTragamonedasCajaTragamonedas:
    '/assets/imagenesJuegos/juegoTragamonedas/cajaTragamonedas',
  rutaTragamonedasCartelesTematica:
    '/assets/imagenesJuegos/juegoTragamonedas/cartelesTematica',
  rutaTragamonedasFondo: '/assets/imagenesJuegos/juegoTragamonedas/fondo',
  rutaTragamonedasNumerosDisplay:
    '/assets/imagenesJuegos/juegoTragamonedas/numerosDisplay',
  rutaTragamonedasPalanca: '/assets/imagenesJuegos/juegoTragamonedas/palanca',
  rutaTragamonedasValoresTragamonedas:
    '/assets/imagenesJuegos/juegoTragamonedas/valoresTragamonedas',

  /*/=======================================================================================\*\
  || ASSETS BLACKJACK                                                                        ||
  \*\=======================================================================================/*/
  rutaBlackJackPantallaCarga:
    '/assets/imagenesJuegos/juegoBlackJack/pantallaCarga',
  rutaBlackJackDisposicion: '/assets/imagenesJuegos/juegoBlackJack/disposicion',
  rutaBlackJackBotones: '/assets/imagenesJuegos/juegoBlackJack/botones',
  rutaBlackJackCartas: '/assets/imagenesJuegos/juegoBlackJack/cartas',
  rutaBlackJackCartelesMano:
    '/assets/imagenesJuegos/juegoBlackJack/cartelesMano',
  rutaBlackJackDisplays: '/assets/imagenesJuegos/juegoBlackJack/displays',
  rutaBlackJackFichasEleccion:
    '/assets/imagenesJuegos/juegoBlackJack/fichasEleccion',
  rutaBlackJackFichasAlfombra:
    '/assets/imagenesJuegos/juegoBlackJack/fichasAlfombra',
  rutaBlackJackFlechaMano: '/assets/imagenesJuegos/juegoBlackJack/flechaMano',
  rutaBlackJackFondo: '/assets/imagenesJuegos/juegoBlackJack/fondo',
  rutaBlackJackMensajesPanel:
    '/assets/imagenesJuegos/juegoBlackJack/mensajesPanel',
  rutaBlackJackNumerosDisplay:
    '/assets/imagenesJuegos/juegoBlackJack/numerosDisplay',
};
